import { Route } from 'react-router-dom';
import React from 'react';
import Login from '../../modules/auth/Login';

const PublicRoutes = [
  <Route path="/auth/login" element={
    <Login />
  } />
];

export default PublicRoutes;